import Favorites from './Favorites.jsx';

export default Favorites;
